import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';

export default css({
  '.reopen-brief-button': {
    color: COLORS.WHITE,
    backgroundColor: COLORS.RED200,
    '&:hover': {
      backgroundColor: COLORS.RED500,
      color: COLORS.WHITE,
    },
  },
});
